import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  WithoutCollidingProps,
} from '../../theming';

export interface BasePathProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

type NonCollidingPathProps = WithoutCollidingProps<BasePathProps, 'path'>;
type NonCollidingPathKeys = keyof NonCollidingPathProps;

export const Path = styled<'path', NonCollidingPathKeys>('path', {
  shouldForwardProp: (prop): prop is NonCollidingPathKeys =>
    shouldForwardProp(prop as NonCollidingPathKeys),
})<BasePathProps>(
  defineWithTheme('paths'),
  compose(
    background,
    border,
    color,
    display,
    layout,
    position,
    shadow,
    space,
    typography,
  ),
);

export type PathProps = React.ComponentPropsWithRef<typeof Path>;
